import { _ep0, _mw1, command } from "../commandBuilder";
import { CreateMultipartUpload$ } from "../schemas/schemas_0";
export class CreateMultipartUploadCommand extends command(_ep0, _mw1, "CreateMultipartUpload", CreateMultipartUpload$) {
}
